export default __webpack_public_path__ + "static/media/graha-black.0a08959f.png";